/******* Angular Resourse *******/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/******* Plug-In Resourse *******/
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/******* Core Resourse *******/
import { CoreCommonModule } from '@core/common.module';

/******* Component Resourse *******/
import { DisclaimerComponent } from './disclaimer.component';


@NgModule({
  declarations: [DisclaimerComponent],
  imports: [
    CommonModule, 
    NgbModule,
    CoreCommonModule
  ],
  providers: [],
  exports: [DisclaimerComponent]
})
export class DisclaimerModule {}
